import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TechpackUploadEnvProvider } from './techpack-upload.env.provider';
import {
  TREQUEST_DeleteTechpackFileForBuyerStyle,
  TREQUEST_TechpackUploadListingByBuyerStyle,
  TRESPONSE_DeleteTechpackFileForBuyerStyle,
  TRESPONSE_FetchBuyersListByStyle,
  TRESPONSE_FetchStylesListByBuyer,
  TRESPONSE_TechpackUploadListingByBuyerStyle,
  TRESPONSE_TechpackDropdownFilterData,
} from '@monorepo/types';
import { of } from 'rxjs';
import { getUploadsListing } from './mocks';

@Injectable({
  providedIn: 'root',
})
export class TechpackUploadDataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private techpackUploadEnvProvider: TechpackUploadEnvProvider) {}

  getFiltersDropdownData(factoryId: string) {
    const URL = this.techpackUploadEnvProvider.getEnvVar('GET_FILTERS_DROPDOWN_DATA') + `/${factoryId}`;
    return this.http.get<TRESPONSE_TechpackDropdownFilterData>(URL, this.httpOptions);
  }

  fetchStylesListByBuyer(factoryId: string, buyer: string) {
    const URL = this.techpackUploadEnvProvider.getEnvVar('GET_STYLES_BY_BUYER') + `/${factoryId}`;
    const params = new HttpParams().set('buyer', buyer);
    return this.http.get<TRESPONSE_FetchStylesListByBuyer>(URL, {
      params,
      ...this.httpOptions,
    });
  }

  fetchBuyersListByStyle(factoryId: string, style: string) {
    const URL = this.techpackUploadEnvProvider.getEnvVar('GET_BUYERS_BY_STYLE') + `/${factoryId}`;
    const params = new HttpParams().set('style', style);
    return this.http.get<TRESPONSE_FetchBuyersListByStyle>(URL, {
      params,
      ...this.httpOptions,
    });
  }

  getTechpackUploadsListing(payload: TREQUEST_TechpackUploadListingByBuyerStyle) {
    // return of(getUploadsListing());
    const URL = this.techpackUploadEnvProvider.getEnvVar('GET_TECHPACK_UPLOADS_LISTING');
    return this.http.post<TRESPONSE_TechpackUploadListingByBuyerStyle>(URL, payload, this.httpOptions);
  }

  deleteTechpack(payload: TREQUEST_DeleteTechpackFileForBuyerStyle) {
    const URL = this.techpackUploadEnvProvider.getEnvVar('DELETE_TECHPACK');
    return this.http.post<TRESPONSE_DeleteTechpackFileForBuyerStyle>(URL, payload, this.httpOptions);
  }
}
